import { Stack, Box, Text, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, Input, FormLabel, Select, Button, Textarea } from "@chakra-ui/react";
import 'services/Recruit/assets/css/CreateJobOpening/style.css';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { globalStyles } from "common/theme/styles";
import { Field, Formik, Form } from "formik";
import CustomDatePicker from "common/components/datePicker/CustomDatePicker";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import { constant } from "common/constant";
import ActionNavbar from "common/components/actionBar/ActionNavbar";
import { useDispatch, useSelector } from "react-redux";
import { getDepartments } from "common/redux/reducers/departmentSlice";
import { fetchUserData } from "common/redux/reducers/userSlice";
import { addRecruitmentProfile } from "common/redux/reducers/recruitmentSlice";
import { uploadAttachment } from "common/redux/reducers/attachmentSlice";
import { campgainTabsData } from "services/Recruit/data/campgain";
import { CAMPGAIN_CREATE_INITIAL_VALUES } from "services/Recruit/schema/campgainCreateSchema";
import { campgainCreateSchema } from "services/Recruit/schema/campgainCreateSchema";
import { constant } from "services/Recruit/constant";
import { recruitConstant } from "services/Recruit/constant";
import { campaignDataName } from "services/Recruit/data/campgain";
import { campaignStatusName } from "services/Recruit/data/campgain";
import { campaignStatus } from "services/Recruit/data/campgain";


const CampaignCreate = () => {
    const colors = globalStyles.colors;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const { users } = useSelector((state) => state.users);
    const handleSubmit = (values) => {
        console.log(values);
      };
    const handleTabChange = (index) => {
        setActiveTabIndex(index);
    };

    const handleNext = () => {
        if (activeTabIndex < 3) {
            setActiveTabIndex(activeTabIndex + 1);
        }
    };

    const handleBack = () => {
        if (activeTabIndex > 0) {
            setActiveTabIndex(activeTabIndex - 1);
        }
    }

    const handleFileChange = (dispatch, setFieldValue, fieldName) => (e) => {
        const file = e.target.files[0];
        if (file) {
            dispatch(uploadAttachment({ file, setFieldValue: (field, value) => setFieldValue(fieldName, value) }));
        }
    };

    useEffect(() => {
        dispatch(getDepartments());
        dispatch(fetchUserData());
    }, [dispatch]);

    return (
        <div className="pt-75">
            <ActionNavbar
                isCreatePage={true}
            />
            <Stack>
                <Box className="createJobOpening-container">
                    <Box className='createJobOpening-mainContainer'>
                        <Box className='createJobOpening-breadCrumb'>
                            <ArrowBackIcon onClick={() => navigate("/recruit/campaign")} fontSize="20px" />
                            <Text className='createJobOpening-pageTitle'>{recruitConstant.createCampaign}</Text>
                        </Box>
                    </Box>

                    <Formik
                        initialValues={CAMPGAIN_CREATE_INITIAL_VALUES}
                        validationSchema={campgainCreateSchema}
                        onSubmit={(values, { resetForm }) => {
                            dispatch(addRecruitmentProfile({ values, resetForm, navigate }));
                        }}
                    >
                        {({ values, setFieldValue, handleSubmit, errors, dirty, isValid, }) => (

                            <Form onSubmit={handleSubmit}>
                                <Tabs index={activeTabIndex} onChange={handleTabChange} className="createJobOpening-tabsContainer" variant="unstyled" orientation="vertical">
                                    {/* tab list  */}
                                    <TabList w={'40%'} className="createJobOpening-tabListContainer">
                                        {campgainTabsData.map(({ label, Icon }, index) => (
                                            <Tab
                                                className="createJobOpening-tabs"
                                                key={index}
                                                _selected={{
                                                    color: colors.cta['100'],
                                                    borderLeft: "2px solid",
                                                    borderColor: colors.cta['100'],
                                                }}
                                                _hover={{
                                                    color: colors.cta['100'],
                                                }}
                                                _focus={{ boxShadow: "none" }}
                                                display="flex"
                                                alignItems="center"
                                                gap="8px"
                                            >
                                                <Icon size={20} />
                                                {label}
                                            </Tab>
                                        ))}
                                    </TabList>

                                    {/* tab panels */}
                                    <TabPanels w={'60%'} className="createJobOpening-tabsPanelContainer">

                                        {/* job opening tab */}
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">

                                                <Flex gap={'20px'}>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="campaignOwner">{recruitConstant.campaignOwner}<span className="astrick">*</span></FormLabel>
                                                        <Field name="campaignOwner">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.campaignOwner}</option>
                                                                        {
                                                                            campaignDataName.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="type">{recruitConstant.type}<span className="astrick">*</span></FormLabel>
                                                        <Field name="type">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.type}</option>
                                                                        {
                                                                            recruitConstant.typeData.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                                <Flex gap={'20px'}>

                                                    <Box w="50%">
                                                        <FormLabel htmlFor="campaignName">{recruitConstant.campaignName}<span className="astrick">*</span></FormLabel>
                                                        <Field name="campaignName">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.campaignName}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%" 
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                    <Box w={'50%'}>
                                                        <FormLabel htmlFor="statuse">{recruitConstant.status}<span className="astrick">*</span></FormLabel>
                                                        <Field name="statuse">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? recruitConstant.errorText : recruitConstant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.status}</option>
                                                                        {
                                                                            campaignStatusName.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>

                                                <Flex gap="20px" w="100%">
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="startDate">{recruitConstant.startDate} <span className="astrick">*</span></FormLabel>
                                                        <Field name="startDate">
                                                            {({ field, form, meta }) => (
                                                                <>
                                                                    <CustomDatePicker
                                                                        fullWidth={true}
                                                                        startDate={field.value}
                                                                        setStartDate={(date) => form.setFieldValue(field.name, date)}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color="red.500">{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>

                                                    <Box w="50%">
                                                        <FormLabel htmlFor="endDate">{recruitConstant.endDate} <span className="astrick">*</span></FormLabel>
                                                        <Field name="endDate">
                                                            {({ field, form, meta }) => (
                                                                <>
                                                                    <CustomDatePicker
                                                                        fullWidth={true}
                                                                        startDate={field.value}
                                                                        setStartDate={(date) => form.setFieldValue(field.name, date)}
                                                                    />
                                                                    {meta.touched && meta.error && <Text color="red.500">{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                                <Flex gap={'20px'}>

                                                    <Box w="50%">
                                                        <FormLabel htmlFor="expectedRevenue">{recruitConstant.expectedRevenue}<span className="astrick">*</span></FormLabel>
                                                        <Field name="expectedRevenue">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.expectedRevenue}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="budgetCost">{recruitConstant.budgetCost}<span className="astrick">*</span></FormLabel>
                                                        <Field name="budgetCost">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.budgetCost}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                                <Flex gap={'20px'}>

                                                    <Box w="50%">
                                                        <FormLabel htmlFor="actualCost">{recruitConstant.actualCost}<span className="astrick">*</span></FormLabel>
                                                        <Field name="actualCost">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.actualCost}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                    <Box w="50%">
                                                        <FormLabel htmlFor="budgetCost">{recruitConstant.expectedResponse}<span className="astrick">*</span></FormLabel>
                                                        <Field name="expectedResponse">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.expectedResponse}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                                <Flex gap={'20px'}>

                                                    <Box w="50%">
                                                        <FormLabel htmlFor="numberSent">{recruitConstant.numberSent}<span className="astrick">*</span></FormLabel>
                                                        <Field name="numberSent">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Input
                                                                        {...field}
                                                                        type="text"
                                                                        placeholder={recruitConstant.numberSent}
                                                                        borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                    {/* <Box w={'50%'}>
                                                        <FormLabel htmlFor="status">{recruitConstant.status}<span className="astrick">*</span></FormLabel>
                                                        <Field name="status">
                                                            {({ field, meta }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        defaultValue=""
                                                                        borderColor={meta.touched && meta.error ? recruitConstant.errorText : recruitConstant.borderColor}
                                                                    >
                                                                        <option selected hidden value="">{recruitConstant.status}</option>
                                                                        {
                                                                            campaignStatus.map((option) => (
                                                                                <option key={option._id} value={option._id}>
                                                                                    {option}
                                                                                </option>
                                                                            ))}
                                                                    </Select>
                                                                    {meta.touched && meta.error && <Text color={colors.errorText}>{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box> */}
                                                </Flex>


                                            </Box>

                                            <Box className="createJobOpening-tabsPanelFooter">
                                               <Button className="backBtn" variant="primary"  onClick={()=>navigate("/recruit/campaign")}>
                                                    {recruitConstant.back}
                                                </Button>
                                                
                                                <Button className="nextBtn" variant="primary" onClick={handleNext}>{recruitConstant.next}</Button>
                                            </Box>

                                        </TabPanel>
                                        <TabPanel className="createJobOpening-tabsPanel">

                                            <Box className="createJobOpening-tabsPanelBody">

                                                <Flex>
                                                    <Box w={'100%'}>
                                                        <FormLabel htmlFor="description">{recruitConstant.description} <span className="astrick">*</span></FormLabel>
                                                        <Field name="description">
                                                            {({ field, form, meta }) => (
                                                                <>
                                                                    <Textarea
                                                                        {...field}
                                                                        placeholder={recruitConstant.enterDescription}
                                                                        size="md"
                                                                        resize="vertical"
                                                                        minH="100px"
                                                                        w="100%"
                                                                    />
                                                                    {meta.touched && meta.error && <Text color="red.500">{meta.error}</Text>}
                                                                </>
                                                            )}
                                                        </Field>
                                                    </Box>
                                                </Flex>
                                            </Box>

                                            <Box className="createJobOpening-tabsPanelFooter">
                                                <Button className="backBtn" variant="primary" onClick={handleBack}>
                                                    {recruitConstant.back}
                                                </Button>
                                                <Button
                                                    className="nextBtn"
                                                    variant="primary"
                                                    type="submit"
                                                    onClick={()=>navigate("/recruit/campaign")}
                                                    
                                                >
                                                    {id ? recruitConstant.update : recruitConstant.save}
                                                </Button>

                                            </Box>

                                        </TabPanel>
                                    </TabPanels>
                                </Tabs>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Stack>
        </div>
    );
};

export default CampaignCreate;
